import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card, Col, Row } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BASE_URL } from '../../../services/Api';
import { authHeader } from '../../../services/auth-header';

import MDIRTOGRNCONVERT from '../ManufacturingDomestic/Convert';
import POSpareIntConvert from '../PumpSpareInternational/Convert';

function POTOMRNConvert() {
  const navigate = useNavigate();
  const { pointindex, id } = useParams();
  const [potype, setpotype] = useState('');
  const [pocategory, setpocategory] = useState('');
  const [poData, setPoData] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}inspectionReport/findById/${id}`, {
          headers: authHeader(),
        });
        setPoData(response.data);
        setpotype(response.data.inspectionreporttype);
        setpocategory(response.data.inspectionreportcategory);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [id]);

  const renderPageDisplay = () => {
    if (potype === 'Manufacturing' && pocategory === 'Domestic') {
      return <MDIRTOGRNCONVERT />;
    } else if (potype === 'Pump Spare' && pocategory === 'International') {
      return <POSpareIntConvert />;
    }
    return null;
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(`${BASE_URL}purchaseOrder/delete/${id}`, {
          headers: authHeader(),
        });
        if (response.data.length === 0) {
          Swal.fire('Warning', 'PO is present in another module. Delete operation has been cancelled.', 'warning');
        } else {
          navigate(`/poindex/${pointindex}`);
          Swal.fire('Deleted!', 'Deleted successfully.', 'success');
        }
      } catch (error) {
        Swal.fire('Error', error.response?.data || 'An error occurred', 'error');
      }
    }
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>CONVERT INSPECTION TO GRN</h6>
          <div className="view-buttons">
            <Link to={`/poindex/1`}>
              <button className="button-70">BACK</button>
            </Link>
          </div>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select a Product Type:</Form.Label>
                <Form.Select disabled value={potype}>
                  <option value="">--Please choose an option--</option>
                  <option value="Manufacturing">Manufacturing</option>
                  <option value="Pump Spare">Pump Spare</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select a PO Category:</Form.Label>
                <Form.Select disabled value={pocategory}>
                  <option value="">--Please choose an option--</option>
                  <option value="Domestic">Domestic</option>
                  <option value="International">International</option>
                </Form.Select>
              </Form.Group>
            </Col>
            {renderPageDisplay()}
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}

export default POTOMRNConvert;

